module.exports = __webpack_public_path__ + "static/media/mo.94c09d58.svg";